import { useEffect, useCallback } from 'react'

declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

const PIXEL_ID = '785578500883191'
let pixelInitialized = false

function loadPixelScript() {
  if (pixelInitialized) return
  pixelInitialized = true

  const f = window as any
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  if (f.fbq) return

  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v
  const s = b.getElementsByTagName(e)[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', PIXEL_ID)
}

export function useMetaPixel() {
  useEffect(() => {
    loadPixelScript()
    window.fbq('track', 'PageView')
  }, [])

  const trackAddToCart = useCallback(() => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart')
    }
  }, [])

  return { trackAddToCart }
}

// Standalone function for use outside of hooks
export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}
